export default {
  userId: 'ID користувача',
  privacyPolicy: 'політика конфіденційності',
  pl: 'Польща',
  settings: 'налаштування',
  advancedSettings: 'Налаштувати свій вибір',
  agreementTitle: 'Ми цінуємо вашу конфіденційність!',
  settingsInfo: 'На цій сторінці ви можете знайти більше інформації про цілі обробки даних та постачальників, які ми використовуємо на наших веб-сайтах',
  dataAdministratorIs: 'Контролером даних (GDPR, стаття 4.7) є така компанія',
  updatedAt: 'оновлено о',
  acceptAll: 'Прийняти все',
  customizeSelection: 'налаштувати вибір',
  saveAndClose: 'зберегти і закрити',
  findOut: 'дізнатися більше',
  all: 'все',
  necessary: 'Призначення',
  survey: 'Метрики вимірювання',
  marketing: 'Маркетинг',
  social: 'Social media',
  advertisement: 'Pеклама',
  cookies: 'Cookies',
  admin: 'Відхилити все',
  purpose: 'ціль',
  vendor: 'постачальник',
  vendors: 'постачальники',
  name: 'назва',
  value: 'значення',
  unknown: 'невідомий',
  statistics: 'статистика',
  functional: 'функціонування сайту',
  validity: 'термін дії',
  session: 'сесії',
  minute: '1 хвилина',
  hour: '1 година',
  day: '1 день',
  '90days': '90 днів',
  week: '1 тиждень',
  month: '1 місяць',
  '3months': '3 місяців',
  '6months': '6 місяців',
  year: '1 рік',
  '13months': '13 місяців',
  '2years': '2 роки',
  persistent: 'стійкий'
}
